<template>
  <header
    id="site-header"
    class="site-header flex flex-col justify-start"
    :class="{ open: isOpen }"
  >
    <div class="content-max-width flex justify-between">
      <a href="/" class="logo">
        <img src="/images/logo.svg" :alt="data.site_name" />
      </a>

      <div class="right flex items-center lg:block">
        <div class="book-btn hidden lg:block">
          
          <a :href="data.book_now_link" target="_blank" @click="bookNow()" class="btn">Book Now</a>
        </div>

        <button class="hamburger lg:hidden" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>

    <div class="content-max-width nav-dt hidden lg:block">
      <ul class="flex space-x-[28px] mt-[18px] mb-6">
        <!-- <li v-for="(link, index) of nav" :key="index">
          <a :href="link.url">
            {{ link.title }}
          </a>
        </li> -->
        <li :class="['/', '/home'].indexOf(pathname) != -1 ? 'active' : ''">
          <a href="/">Home</a>
        </li>
        <li :class="['/services'].indexOf(pathname) != -1 ? 'active' : ''">
          <a href="/services">Services</a>
        </li>
        <a href="/vet-clinics"><li class="dropdown">
          <a href="/vet-clinics">Vet Clinics<span class="caret-down"></span></a>
          <ul class="drop-links">
            <li v-for="(i, k) in getClinics" :key="k">
              <span><a href="/vet-clinics">{{ k }}</a></span>
              <span class="caret-d-right"></span>
              <ul class="drop-link-list">
                <li v-for="(item, key) in i" :key="key">
                  <a :href="item.url">{{ item.title }}</a>
                </li>
              </ul>
            </li>
          </ul>
        </li></a>
        <li :class="['/puppy-preschool'].indexOf(pathname) != -1 ? 'active' : ''">
          <a href="/puppy-preschool">Puppy Preschool</a>
        </li>
        <li :class="['/shop'].indexOf(pathname) != -1 ? 'active' : ''"><a href="/shop">Shop</a></li>
        <li class="dropdown" v-if="getForms.length > 0">
          <a href="#">Forms<span class="caret-down"></span></a>
          <ul class="drop-links forms">
            <li v-for="(i, k) in getForms" :key="k">
              <a :href="i.link" target="_blank">{{ i.title }}</a>
            </li>
          </ul>
        </li>
        <li :class="['/article'].indexOf(pathname) != -1 ? 'active' : ''">
          <a href="/article">Articles</a>
        </li>
        <li :class="['/highlights'].indexOf(pathname) != -1 ? 'active' : ''">
          <a href="/highlights">Highlights</a>
        </li>
        <li :class="['/careers'].indexOf(pathname) != -1 ? 'active' : ''">
          <a href="/careers">Careers</a>
        </li>
        <li :class="['/about'].indexOf(pathname) != -1 ? 'active' : ''">
          <a href="/about">About</a>
        </li>
         <li :class="['/cattery'].indexOf(pathname) != -1 ? 'active' : ''">
          <a href="/cattery">Cattery</a>
        </li>
      </ul>
    </div>

    <nav>
      <div class="btn-wrap">
        <a :href="data.book_now_link" target="_blank" class="drawer-btn book-btn" @click="bookNow()">Book Now</a>
      </div>
      <ul class="top">
        <!-- <li v-for="(link, index) of nav" :key="index">
          <a :href="link.url">
            {{ link.title }}
          </a>
        </li> -->
        <li class="active"><a href="/">Home</a></li>
        <li><a href="services">Services</a></li>
        <li>
          <div class="accordion-item">
            <nav-accordion :isOuter="true">
              <template #title>
                <p><a href="/vet-clinics">Vet Clinics</a></p>
              </template>
              <template #content>
                <div class="accordion-item" v-for="(i, k) in getClinics" :key="k">
                  <nav-accordion :isInner="true">
                    <template #title>
                      <p><a href="/vet-clinics">{{ k }}</a></p>
                    </template>
                    <template #content>
                      <div class="item-content">
                        <ul>
                          <li v-for="(item, key) in i" :key="key">
                            <a :href="item.url">{{ item.title }}</a>
                          </li>
                        </ul>
                      </div>
                    </template>
                  </nav-accordion>
                </div>
              </template>
            </nav-accordion>
          </div>
        </li>
        <li><a href="/puppy-preschool">Puppy Preschool</a></li>
        <li><a href="/shop">Shop</a></li>
        <li v-if="getForms.length > 0">
          <div class="accordion-item">
            <nav-accordion :isOuter="true">
              <template #title>
                <p>Forms</p>
              </template>
              <template #content>
                <div class="item-content">
                  <ul>
                    <li v-for="(i, k) in getForms" :key="k">
                      <a :href="i.link" target="_blank">{{ i.title }}</a>
                    </li>
                    <!-- <li><a href="#">Form Title Here</a></li> -->
                    <!-- <li><a href="#">Form Title Here</a></li>
                    <li><a href="#">Form Title Here</a></li>
                    <li><a href="#">Form Title Here</a></li> -->
                  </ul>
                </div>
              </template>
            </nav-accordion>
          </div>
        </li>
        <li><a href="/article">Articles</a></li>
        <li><a href="/highlights">Highlights</a></li>
        <li><a href="/careers">Careers</a></li>
        <li><a href="/about">About</a></li>
        <li><a href="/cattery">Cattery</a></li>
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'HeaderModule',

  props: {
    menu: Array,
    data: Object,
    clinics: Object,
    forms: Array,
  },

  data: () => ({
    isOpen: false,
    nav: [],
    pathname: '',
    getForms: [],
    getClinics: [],
  }),

  mounted() {
    this.nav = this.menu
    this.pathname = window.location.pathname
    this.getForms = this.forms ?? []
    this.getClinics = this.clinics ?? []
    // console.log(this.menu, this.nav)
    // console.log(this.pathname, ['/services'].indexOf(this.pathname))
  },

  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen
      if (this.isOpen) this.$parent.$el.className = 'nav-open'
      else this.$parent.$el.classList.remove('nav-open')
    },
    bookNow() {
      //console.log(window)
      window.fbq('trackCustom', 'Vetcare Book Now - Top-right');
      //window.open(this.data.book_now_link, '_blank')
    },
  },
}
</script>
